import React, { useEffect, useState } from "react";
import { listCustomers } from "@/lib/api";
import { Search, X, User2, CircleUserRound } from "lucide-react";

export default function CustomerPicker({ onClose, onPick, currentId }) {
  const [customers, setCustomers] = useState([]);
  const [q, setQ] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    listCustomers(q).then((c) => {
      setCustomers(c);
      setLoading(false);
    });
  }, [q]);

  return (
    <div className="fixed inset-0 z-50 bg-slate-900/50 backdrop-blur-sm flex items-center justify-center p-4">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-lg max-h-[80vh] flex flex-col overflow-hidden">
        <div className="p-4 border-b border-slate-200 flex items-center gap-3">
          <CircleUserRound size={20} className="text-slate-500" />
          <div className="font-display text-lg font-semibold flex-1">Seleccionar cliente</div>
          <button onClick={onClose} className="h-9 w-9 rounded-md hover:bg-slate-100 flex items-center justify-center">
            <X size={18} />
          </button>
        </div>
        <div className="p-3 border-b border-slate-200 relative">
          <Search size={16} className="absolute top-6 left-6 text-slate-400" />
          <input
            autoFocus
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Buscar por nombre o NIF…"
            className="w-full h-11 pl-10 pr-3 rounded-md border border-slate-200 focus:border-slate-400 focus:outline-none text-sm"
          />
        </div>
        <div className="flex-1 overflow-y-auto thin-scroll">
          {loading ? (
            <div className="p-6 text-center text-slate-400 text-sm">Cargando…</div>
          ) : customers.length === 0 ? (
            <div className="p-6 text-center text-slate-400 text-sm">Sin resultados</div>
          ) : (
            customers.map((c) => (
              <button
                key={c.id}
                onClick={() => onPick(c)}
                className={`w-full text-left px-4 py-3 border-b border-slate-100 hover:bg-slate-50 flex items-center gap-3 ${
                  currentId === c.id ? "bg-slate-900 text-white hover:bg-slate-800" : ""
                }`}
              >
                <User2 size={16} className={currentId === c.id ? "text-white" : "text-slate-400"} />
                <div className="flex-1 min-w-0">
                  <div className="font-medium text-sm truncate">{c.name}</div>
                  <div className={`text-xs ${currentId === c.id ? "text-white/70" : "text-slate-500"}`}>
                    {c.nif || "Sin NIF"} {c.balance > 0 && `· Debe ${c.balance.toFixed(2)}€`}
                  </div>
                </div>
                {c.credit_limit > 0 && (
                  <div className={`text-[11px] font-mono ${currentId === c.id ? "text-white/70" : "text-slate-500"}`}>
                    Crédito: {c.credit_limit.toFixed(0)}€
                  </div>
                )}
              </button>
            ))
          )}
        </div>
      </div>
    </div>
  );
}
